import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { CostForwarding } from "models/utilTypes/costForwardingTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { getCostForwardingInvoiceLink } from "./costForwardingMarkingModel";
//#endregion
//#region components
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { ActionLinkButton, Icon } from "components/common";
import useInvoicePermissions from "components/invoice/useInvoicePemissions";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const CostForwardingInvoiceLink: React.FC<{ marking: CostForwarding }> = ({ marking }) => {
  const { canUseInvoices } = useInvoicePermissions();
  const navigate = useNavigate();
  const location = useLocation();
  const invoiceLink = getCostForwardingInvoiceLink(marking, !!canUseInvoices);
  if (!invoiceLink) return <></>;

  return (
    <Box mt={0.5}>
      <ActionLinkButton
        className={cssExports.animatedLink}
        onClick={() =>
          navigate(UrlHelper.formatPath(`/Invoice/${invoiceLink.invoiceId}`), {
            state: { background: location },
          })
        }
        testId="costForwardingViewInvoice"
      >
        {LocalizationHelperInstance.getFormattedMessage(
          invoiceLink.key === "ViewInvoiceDraft"
            ? TranslationKeys.CostForwarding.ViewInvoiceDraft
            : TranslationKeys.Common.ViewInvoice
        )}
        <Icon icon={IconDefinitionConstants.WArrowSmallRight} displayType={StyleEnums.DisplayType.Info} />
      </ActionLinkButton>
    </Box>
  );
};

export default CostForwardingInvoiceLink;
